// config.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//const APP_BASE_URL = process.env.REACT_APP_BASE_URL;
export default API_BASE_URL;
